import axiosInstance from './../providers/Axios';

import { getProfileCategory } from '../config/paths';

export const callGetUserCategory = async (logonId) => {
  return axiosInstance({
    url: `${getProfileCategory}/${logonId}`,
    method: 'get',
  });
};
